import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BADeviceList from './components/BADeviceList';

const { Cell } = ResponsiveGrid;

const BADevice = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="BA裝置"
        breadcrumbs={[
          {
            name: 'BA系統',
          },
          {
            name: 'BA裝置',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BADeviceList />
    </Cell>
  </ResponsiveGrid>
);

export default BADevice;
